const servers = {
    //PRO
    "nebrijaprofesional.nebrija.es": "https://gestiondcp.nebrija.es",
    //PRE
    "portal-nebrija.dev.doubledot.es": "https://sandbox-nebrija.dotia.es",
    //FORMACIÓN
    "portal-nebrija2.dev.doubledot.es": "https://sandbox-nebrija2.dotia.es",
    //LOCAL
    "localhost:8080": "https://sandbox-nebrija.dotia.es",
}

export default servers;


// WEBPACK FOOTER //
// ./src/servers/index.js